import env from "config/env";
import { useEffect } from "react";

const GoogleDrivePickers = ({ files_send_to_parent, assistant_id }) => {
  const GDriveURL = `${env.GDriveURL}`;
  const openPicker = () => {
    const popup = window.open(
      GDriveURL,
      "GoogleDrivePicker",
      "width=800,height=700"
    );

    if (!popup) {
      alert("Popup blocked! Please allow popups for this site.");
      return;
    }

    const interval = setInterval(() => {
      if (popup.closed) {
        clearInterval(interval);
        console.log("Popup closed by user.");
      } else {
        try {
          popup.postMessage({ action: "openPicker" }, "*");
          clearInterval(interval); // Stop the interval after message is sent
        } catch (err) {
          console.error("Error posting message:", err);
        }
      }
    }, 500);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.action === "filesSelected") {
        console.log("Files received:", event.data.files);
        files_send_to_parent(event.data.files, "GoogleDrive", assistant_id);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <div>
      <button onClick={openPicker} style={{ background: "none", border: "none", cursor: 'pointer' }}>
        Connect Google Drive
      </button>
    </div>
  );
};

export default GoogleDrivePickers;
